import $ from 'jquery';

class mobileTabs  {

  constructor() {
    this.showTabOptions = $(".nav-tabs a");
    this.events();
    this.isShow = false;
    this.screenWidth = $(window).width();
  }

  events() {
    this.showTabOptions.on('click', this.showAllOptions.bind(this));
  }

  showAllOptions(e) {
    e.preventDefault();
    this.screenWidth = $(window).width();
    if (this.screenWidth < 767) {
      $(".nav-tabs a").removeClass('show');
      if (!this.isShow) {
        this.showTabOptions.addClass('show');

        $("li.nav-item").each(function (index) {
          if ($('a', this).hasClass('active')) {
            $('a', this).addClass('show');
            $(this).closest('li').addClass('showOption');
          } else {
            $(this).closest('li').removeClass('showOption');
          }
        });

        this.isShow = true;
      } else {
        this.showTabOptions.removeClass('show');

        $("li.nav-item").each(function (index) {
          if ($('a', this).hasClass('active')) {
            $(this).closest('li').addClass('showOption');
          } else {
            $(this).closest('li').removeClass('showOption');
          }
        });

        this.isShow = false;
      }
    }
  }

}

export default mobileTabs;